import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Column } from 'components/shared/Layout';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { VerticalLine, StyledPrice, StyledHr, LastColumn } from '../Extras.styles';

const SubscriptionDetails = ({ firstName, lastName, startDate, endDate, name, currency, price }) => (
  <>
    <Row>
      <Column span={4}>
        <VerticalLine>
          <strong>
            <FormattedMessage id="subscriptions.passenger" />
          </strong>
          <div data-testid={`subscriptions.passenger`}>
            {firstName} {lastName}
          </div>
        </VerticalLine>
      </Column>
      <Column span={3}>
        <VerticalLine>
          <strong>
            <FormattedMessage id="subscriptions.startDate" />
          </strong>
          <div data-testid={`subscriptions.startDate`}>{startDate}</div>
        </VerticalLine>
      </Column>
      <Column span={3}>
        <VerticalLine>
          <strong>
            <FormattedMessage id="subscriptions.endDate" />
          </strong>
          <div data-testid={`subscriptions.endDate`}>{endDate}</div>
        </VerticalLine>
      </Column>
      <Column span={4}>
        <LastColumn>
          <strong>
            <FormattedMessage id="subscriptions.description" />
          </strong>
          <div data-testid={`subscriptions.description`}>{name}</div>
        </LastColumn>
      </Column>
    </Row>

    <StyledHr />
    <Row span={16}>
      <StyledPrice data-testid={`extras.total`}>
        <FormattedMessage id="extras.total" />: <FormattedCurrency currency={currency} amount={price} />
      </StyledPrice>
    </Row>
  </>
);

SubscriptionDetails.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  name: PropTypes.string,
  currency: PropTypes.string,
  price: PropTypes.number,
  bookingWithin14DaysCoolingOffPeriod: PropTypes.bool
};

export default SubscriptionDetails;
